import { useShallow } from "zustand/shallow";

import { VoteByEventId, VoteType } from "api/vote";
import Pending from "containers/Pending";
import useBoundStore from "store";

interface EventPendingVotesProps {
  onBack?: () => void;
}

export default function EventPendingVotes(props: EventPendingVotesProps): JSX.Element {
  const { onBack } = props;
  const selected = useBoundStore((state) => state.selected);
  const { groups, groupsUsers, stateVotes } = useBoundStore(
    useShallow((state) => ({
      groups: state.appData.groups,
      groupsUsers: state.appData.groupsUsers,
      stateVotes: state.appData.votes,
    }))
  );

  const group = groups.find((g) => g.id === selected.groupId);
  const pendingVotes: VoteByEventId[] = [];
  const participantsUids: number[] = [];
  const votes = stateVotes;
  votes.forEach((vote) => {
    if (vote.event_id === selected.eventId) {
      if (vote.type === VoteType.PENDING) {
        pendingVotes.push(vote);
      } else {
        participantsUids.push(vote.uid);
      }
    }
  });
  const users = groupsUsers
    .filter((user) => group?.users.includes(user.uid))
    .filter((user) => !participantsUids.includes(user.uid));

  return <Pending users={users} votes={pendingVotes} onBack={onBack} />;
}
